/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Input_UploadingInputs */

const en_file_input_uploading = /** @type {(inputs: File_Input_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading...`)
};

const de_file_input_uploading = /** @type {(inputs: File_Input_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird hochgeladen...`)
};

/**
* | output |
* | --- |
* | "Uploading..." |
*
* @param {File_Input_UploadingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const file_input_uploading = /** @type {((inputs?: File_Input_UploadingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Input_UploadingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_file_input_uploading(inputs)
	return en_file_input_uploading(inputs)
});